import { useSearchParams } from "next/navigation";
import { useState, useTransition } from "react";
import { useDebounce } from "./use-debounce";
import { useGridToggle } from "./use-grid-toggle";
import { useModeType } from "./use-mode-type";
import { useStore } from "./use-store";


export const useCollection = () => {
  const gridToggle = useStore(useGridToggle, (s) => s);
    const modeType = useStore(useModeType, (s) => s);
    const [isPending, startTransition] = useTransition();
   
    
    
    const searchParams = useSearchParams();
    const currentType = searchParams.get("type") || "mixtape";
    const currentPage = Number(searchParams.get("page") || "0");
    const currentGenre = searchParams.get("genre") || null;
    const currentQuery = searchParams.get("query") || null;
    const [type, setType] = useState(currentType);
    const [searchTerm, setSearchTerm] = useState(currentQuery || "");
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
   
    const [pagination, setPagination] = useState({ pageIndex: currentPage, pageSize: 10 });
    const [selectedGenre, setSelectedGenre] = useState<string | null>(currentGenre);

    const handleChangeGenre = (genre: string | null) => {
      startTransition(() => {
      setSelectedGenre(genre);
      setPagination({ pageIndex: 1, pageSize: pagination.pageSize });
      setSearchTerm("");
      })
    };
    
    const handleChangeType = (type: string) => {
      startTransition(() => {
      setType(type);
      setPagination({ pageIndex: 1, pageSize: pagination.pageSize });
      setSelectedGenre(null);
      setSearchTerm("");})
    };
    
    
 

    return{
      gridToggle,
      modeType,
      searchTerm,
      setSearchTerm,
      debouncedSearchTerm,
      selectedGenre,
      setSelectedGenre,
      pagination,
      setPagination,
      currentPage,
      currentType,
      type,
      setType,
      startTransition,
      handleChangeType,
      handleChangeGenre,
      isPending
    }
}